import "./index.scss";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { userApplicationTracker } from "../../../../store/features/UserDashboard/NewUserDashboard/ApplicationTracker/ApplicationTrackerApi";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";

const QuickLinks = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const dashState: any = useAppSelector((store: RootStore) => {
    return store.NewDashboard;
  });

  const tracker: any = useAppSelector((store: RootStore) => {
    return store.UserApplicationTracker;
  });

  const handleNavigation = (link: any) => {
    const myArray = link.url.split("/");
    // if (myArray[myArray.length - 1] === "user-application-tracking") {
    //   dispatch(userApplicationTracker());
    //   return;
    // }
    if (link.open_new_tab) {
      window.open(link.url, "_blank");
    }
    if (!link.open_new_tab) {
      navigate(`/${myArray[myArray.length - 1]}`);
    }
  };
  return (
    <div className="quick__links__wrapper">
      <div className="center_wrapper handle__margin">
        <h1 className="title"> Quick Links & Resources</h1>
        <div className="quick__links__section">
          {!tracker.loading.link &&
            !dashState.loading.quick_links &&
            dashState.req_success.quick_links &&
            dashState.quick_links.map((link: any) => {
              return (
                <div
                  role="button"
                  aria-hidden
                  className="link__card"
                  key={link.id}
                  onClick={() => handleNavigation(link)}
                >
                  <div className="icon__bg">
                    <img src={link.icon} alt="archvie" className="icon" />
                  </div>
                  <span className="link__title">{link.title}</span>
                  <p className="link__desc">{link.description} </p>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default QuickLinks;
